@use "variables" as *;

.number {
  font-size: $fontSize-xl;
  font-weight: bold;
  width: 40px;
}

.incrementalButton {
  font-size: $fontSize-xl;
  font-weight: bolder;
}
